import * as ticketsGroupActions from '../actions/Budgets';

const initialState = {
  list: [],
  status: 200
};

const ticketsGroup = (state = initialState, action) => {
  switch (action.type) {
    case ticketsGroupActions.GET_TICKETS_GOCHI_SUCCESS:
      return Object.assign({}, state, { list: action.payload });
    case ticketsGroupActions.GET_TICKETS_GOCHI_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default ticketsGroup;
